import React from "react";
import { MobileMenu } from "../HeaderMobileMenu/HeaderMobileMenu";
import { HeaderLogo } from "../HeaderLogoBlock/HeaderLogoBlock";
import { HeaderMenu } from "../HeaderMenu/HeaderMenu";
import { HeaderActions } from "../HeaderActions/HeaderActions";
import { HeaderSearch } from "../HeaderSearch/HeaderSearch";

export default function HeaderSplit2RowLeft({
  links,
  item_count = "",
  settings,
}) {
  // Check if the dedicated search block exists
  const hasSearchBlock = settings.blocks.some(block => block.type === "search_bar");
  
  return (
    <div className={"header-rows"}>
      <div className={"header-row"}>
        <HeaderLogo settings={settings} />
        
        {/* Use the new HeaderSearch component */}
        <div className={"header-search"}>
          {hasSearchBlock ? (
            <HeaderSearch settings={settings} />
          ) : (
            settings.section?.enable_searchbar && (
              <HeaderSearch settings={settings} />
            )
          )}
        </div>
        
        <HeaderActions item_count={item_count} settings={settings} />
      </div>
      <div className={`header-row`}>
        <MobileMenu link_list={links} settings={settings} />
        <HeaderMenu link_list={links} settings={settings} />
      </div>
    </div>
  );
}
